import { Button } from '@schibsted-svp/react-ui';

import type { FC } from 'react';
import type { Filter as FilterModel } from '../types';

import styles from './Filter.module.scss';

type Props = {
  filter: FilterModel;
  onRemoveClick: (filter: FilterModel) => void;
};

const Filter: FC<Props> = ({ filter, onRemoveClick }) => {
  const title = filter[filter.type]?.title;

  return (
    <div className={styles.filter}>
      <span className={styles.type}>{filter.type}:</span>
      <span className={styles.title}>{title}</span>
      <Button
        type="button"
        variant="standard"
        size="compact"
        className={styles.button}
        onClick={() => onRemoveClick(filter)}
      >
        × Remove
      </Button>
    </div>
  );
};

export { Filter };
